module.exports = __webpack_public_path__ + "static/img/products_redmud.ea5300f8.jpg";